<template>
  <UserPhoneColumn :row="owner.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserPhoneColumn from '@/components/GraphqlDataTable/columns/User/UserPhoneColumn.vue'

const OwnerPhoneColumn = graphql(`
  fragment OwnerPhoneColumn on Owner {
    id
    user {
      id
      ...UserPhoneColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerPhoneColumn>
  rowIndex?: number
}>()

const owner = computed(() => useFragment(OwnerPhoneColumn, props.row))
</script>
